import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface OtpHttpError extends HttpErrorResponse {
  isOtpError?: true;
}

export const otpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message: string | undefined;

      if (typeof error.error === 'string') {
        message = error.error;
      } else if (typeof error.error === 'object' && error.error?.message) {
        message = error.error.message;
      }

      if (message?.toLowerCase().includes('totp')) {
        return throwError(
          () =>
            ({
              ...error,
              isOtpError: true,
            } satisfies OtpHttpError),
        );
      }

      return throwError(() => error);
    }),
  );
};
